export const adminEn = {
    title: "Admin Panel",
    usersList: "Users List",
    createUser: "Create New User",
    userName: "User Name",
    userEmail: "Email",
    userPassword: "Password",
    userRole: "Role",
    roleUser: "User",
    roleAdmin: "Administrator",
    userLanguage: "Language",
    studiesCount: "Studies Count",
    activeStudy: "Active study",
    activeStudyBadge: "active",
    noActiveStudy: "None",
    actions: "Actions",
    delete: "Delete",
    cancel: "Cancel",
    create: "Create",
    loading: "Loading...",
    noUsers: "No Users",
    noUsersMessage: "No users found in the system.",
    deleteConfirm: "Are you sure you want to delete this user?",
    userCreated: "User created successfully",
    userDeleted: "User deleted successfully",
    errorFetching: "Error fetching users list",
    errorCreating: "Error creating user",
    errorDeleting: "Error deleting user",
    viewStudies: "View Studies",
    userStudies: "User Studies",
    loadingStudies: "Loading studies...",
    noStudies: "No Studies",
    noStudiesMessage: "This user has no studies yet.",
    study: "Study",
    studyName: "Study Name",
    unnamedStudy: "Unnamed",
    marks: "Comparison Categories",
    mark: "Category",
    options: "Options",
    results: "Results",
    comparisons: "comparisons",
    status: "Status",
    completed: "Completed",
    incomplete: "Incomplete",
    close: "Close",
    errorFetchingStudies: "Error fetching user studies",
    usersView: "Users",
    studiesView: "Studies",
    translationsView: "Translations",
    studiesList: "Studies List",
    createStudy: "Create New Study",
    editStudy: "Edit Study",
    studyUsers: "Users",
    breakTime: "Break time",
    breakMinutes: "Break minutes",
    breakSeconds: "Break seconds",
    breakAfterMark: "Add break after this category",
    markTitle: "Category header",
    markTitlePlaceholder: "Example: Habitat benefits",
    pageGroup: "Category page",
    addOption: "Add option",
    optionLabel: "Option",
    pageLabel: "Page",
    pageTypeStart: "Start",
    pageTypeCategories: "Categories",
    pageTypeBreak: "Break",
    pageTypeEnd: "End",
    addBreakPage: "Add break page",
    addCategoriesPage: "Add categories page",
    deletePage: "Delete page",
    movePageLeft: "Move left",
    movePageRight: "Move right",
    setAsActiveStudy: "Set as user's active study",
    activeStudyUpdated: "Active study updated",
    errorUpdatingActiveStudy: "Error updating active study",
    pageText: "Page text",
    pageTextPlaceholder: "Enter page content",
    defaultPageTextHint: "This field is empty — the user will see the default text below:",
    categoriesPageTitle: "Categories page title",
    categoriesPageTitlePlaceholder: "For example: Part 1",
    downloadStudyJson: "Download JSON",
    importStudyJson: "Import from JSON",
    invalidStudyJson: "Invalid study JSON file",
    introText: "Start page text",
    introTextPlaceholder: "Study introduction text",
    breakText: "Break page text",
    breakTextPlaceholder: "Break message text",
    endText: "End page text",
    endTextPlaceholder: "Text before submission",
    marksCount: "Categories Count",
    edit: "Edit",
    noUsersAssigned: "No users assigned",
    studyCreated: "Study created successfully",
    studyUpdated: "Study updated successfully",
    studyDeleted: "Study deleted successfully",
    errorCreatingStudy: "Error creating study",
    errorUpdatingStudy: "Error updating study",
    errorDeletingStudy: "Error deleting study",
    deleteStudyConfirm: "Are you sure you want to delete this study?",
    studyNamePlaceholder: "Enter study name",
    selectUsers: "Select users",
    optionsPlaceholder: "Options separated by | (e.g: Option 1 | Option 2 | Option 3)",
    optionsHint: "Enter options separated by | (you can use commas within options)",
    addMark: "Add Category",
    noMarks: "No categories. Add a category to create a study.",
    update: "Update",
    translationsSectionTitle: "Translations",
    userViewTranslationsTitle: "User view translations",
    adminPanelTranslationsTitle: "Admin panel translations",
    downloadTranslations: "Download JSON",
    uploadTranslations: "Upload JSON",
    translationLanguage: "Language",
    uploadNewTranslationVersion: "Upload new version",
    noUploadedTranslations: "No uploaded translations",
    noUploadedTranslationsMessage: "Add a language or upload a JSON file to see it on the list.",
    invalidTranslationsFile: "Invalid translations JSON file",
    translationValidationTitle: "Invalid translation structure",
    translationValidationHint: "The file must contain the same keys as the reference translation for the selected section.",
    translationMissingKeys: "Missing keys",
    translationExtraKeys: "Unknown keys",
    translationsUploaded: "Translations file uploaded",
    translationVersionUploaded: "New translation version uploaded",
    errorFetchingTranslations: "Error fetching translations",
    errorUploadingTranslations: "Error uploading translations",
    addCustomLanguage: "Add custom language",
    translationLanguageName: "Language name",
    uploadLanguageFile: "Translation file (JSON)",
    translationFileReady: "JSON file is ready",
    customLanguageCreated: "Custom language created",
    errorCreatingCustomLanguage: "Error creating custom language",
    deleteCustomLanguage: "Delete language",
    deleteCustomLanguageConfirm: "Are you sure you want to delete this language? This cannot be undone.",
    customLanguageDeleted: "Language deleted",
    errorDeletingCustomLanguage: "Error deleting language",
    cannotDeleteBuiltInLanguage: "Built-in language cannot be deleted",
    userLanguageUpdated: "User language updated",
    errorUpdatingUserLanguage: "Error updating user language",
    responsesView: "Responses",
    responsesList: "Responses list",
    noResponses: "No responses",
    noResponsesMessage: "No submitted responses were found.",
    submissionHistory: "Submission history",
    submittedAt: "Submitted at",
    updatedAt: "Updated at",
    viewResponses: "View responses",
    viewSubmission: "View response",
    ranking: "Ranking",
    consistencyRatio: "Consistency ratio (CR)",
    comparisonMatrix: "Comparison matrix",
    loadingResponses: "Loading responses...",
    errorFetchingResponses: "Error fetching responses",
    lastSubmission: "Last submission",
    submissionsCount: "Submissions count",
    submissionDetails: "Response details",
    exportSubmissionCsv: "Export CSV",
    weight: "Weight",
    noSubmissionHistory: "No submission history",
    noSubmissionHistoryMessage: "This user has not submitted answers for this study yet.",
    studyContentTab: "Study content",
    studyTranslationsTab: "Translations",
    studyLanguages: "Languages",
    defaultLanguage: "Source language",
    selectTranslationLanguage: "Add language",
    noStudyTranslations: "No additional translations",
    noStudyTranslationsMessage: "Select a language to add a translation of the study content.",
    deleteStudyTranslation: "Delete translation"
}

export default adminEn
